import React from 'react';

import IngkaToast, { ToastProps } from '@ingka/toast';

const Toast = (props: ToastProps) => (
    <IngkaToast prefix="list-ingka-" {...props} />
);

export default Toast;
